import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=bd063b3e&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports